<template>
  <b-container>

    <pdf
      v-for="i in numPages"
      :key="i"
      :page="i"
      style="display: inline-block; width: 100%;"
      :src="src"></pdf>

  </b-container>
</template>

<script>

import pdf from "vue-pdf";

export default {

  name: 'PrivacyPolicy',

  data() {
    return {
      src: null,
      numPages: undefined,
    }
  },

  mounted() {

    this.src = pdf.createLoadingTask('./../../../static/privacyPolicy.pdf')

    this.src.promise.then(pdf => {

      this.numPages = pdf.numPages;
    });
  }

}

</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/views/CGU/PrivacyPolicy.vue